import { Typography } from "@mui/material";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import { useCalculateShipmentPriceMutation } from "src/_api/mapitShipApi";
import { $APP_NAME } from "src/constants";
import {
  DeliveryCompaniesListContainer,
  OrderShipmentDetailsCard,
} from "./components";
import { useEffect, useState } from "react";
import OrdrContextProvider from "./OrdrContextProvider";
import { omitBy } from "lodash";
import { DEFAULT_SHIPMENT_PAYLOAD } from "./shipmentDefaults";

export default function PriceCalculator() {
  const { t } = useTranslation();

  const [isEditing, setIsEditing] = useState(false);

  const isEditingChangeHandler = (value) => {
    setIsEditing(value);
  };

  //======= Get delivery companies by shipment dimentions =======
  const [serviceType, setServiceType] = useState("");
  const [shipmentPayload, setShipmentPayload] = useState(
    DEFAULT_SHIPMENT_PAYLOAD,
  );


  const [
    calculateShipmentPrice,
    { data: companies, isLoading: companiesLoading },
  ] = useCalculateShipmentPriceMutation();

  const saveShipmentsHandler = async (payload) => {
    setShipmentPayload(payload);
    setIsEditing(false);
  };
  
  useEffect(() => {
    if (!isEditing && shipmentPayload) {
      calculateShipmentPrice(
        omitBy(
          {
            ...shipmentPayload,
            serviceType,
          },
          (v) => v === "" || v === undefined || v === null,
        ),
      );
    }
  }, [calculateShipmentPrice, isEditing, serviceType, shipmentPayload]);

  return (
    <>
      <Helmet>
        <title>Price calculator | {$APP_NAME}</title>
      </Helmet>
      <Typography variant="h2" sx={{ mb: 2 }}>
        {t("Price Calculator")}
      </Typography>
      <OrdrContextProvider order={undefined} orderLoading={false}>
        <OrderShipmentDetailsCard
          isEditing={isEditing}
          isEditingChangeHandler={isEditingChangeHandler}
          order={undefined}
          onSaveShipment={saveShipmentsHandler}
          loading={companiesLoading}
          closeEditCards={!!companies}
          priceCalculatorMode={true}
        />
        {!isEditing && (
          <DeliveryCompaniesListContainer
            companies={companies}
            companiesLoading={companiesLoading}
            orderId={undefined}
            serviceType={serviceType}
            setServiceType={setServiceType}
          />
        )}
      </OrdrContextProvider>
    </>
  );
}
